import { render } from "./GuidedCreationLogistics.vue?vue&type=template&id=f41bdb4a&scoped=true"
import script from "./GuidedCreationLogistics.vue?vue&type=script&lang=js"
export * from "./GuidedCreationLogistics.vue?vue&type=script&lang=js"

import "./GuidedCreationLogistics.vue?vue&type=style&index=0&id=f41bdb4a&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41bdb4a"]])

export default __exports__